import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Loader from '../../common/loader/LoaderComponent';
import useClasses from './ButtonStyle';
import { white, saffronMango } from '../../../constants/Colors';

const RegularButton = React.forwardRef((props, ref) => {
    const {
        color,
        round,
        children,
        fullWidth,
        disabled,
        simple,
        size,
        block,
        link,
        justIcon,
        fileButton,
        className,
        spin,
        testId = 'button',
        loaderSize = 35,
        ...rest
    } = props;

    const classes = useClasses();

    const btnClasses = clsx({
        [classes.button]: true,
        [classes[size]]: size,
        [classes[color]]: color,
        [classes.round]: round,
        [classes.fullWidth]: fullWidth,
        [classes.disabled]: disabled,
        [classes.simple]: simple,
        [classes.block]: block,
        [classes.link]: link,
        [classes.justIcon]: justIcon,
        [classes.fileButton]: fileButton,
        [className]: className,
    });

    const loader = <Loader
        color={color === 'secondary' ? saffronMango : white}
        width={loaderSize}
        height={loaderSize}
        transparentBackground
    />;

    const buttonInners = spin ? <span style={{ visibility: 'hidden' }}>{children}</span> : children;

    return (
        <Button {...rest} className={btnClasses} data-test-id={testId} startIcon={spin && loader} ref={ref}>
            {buttonInners}
        </Button>
    );
});

RegularButton.propTypes = {
    testId: PropTypes.string,
    classes: PropTypes.object,
    color: PropTypes.oneOf([
        'primary',
        'secondary',
        'tertiary',
        'info',
        'success',
        'warning',
        'danger',
        'rose',
        'white',
        'twitter',
        'facebook',
        'google',
        'linkedin',
        'pinterest',
        'youtube',
        'tumblr',
        'github',
        'behance',
        'dribbble',
        'reddit',
        'instagram',
        'transparent',
        'cornFlowerBlue',
        'cornFlowerBlueTransparent',
        'cornFlowerBlueDialog',
    ]),
    size: PropTypes.oneOf(['sm', 'md', 'lg']),
    simple: PropTypes.bool,
    round: PropTypes.bool,
    fullWidth: PropTypes.bool,
    disabled: PropTypes.bool,
    block: PropTypes.bool,
    link: PropTypes.bool,
    justIcon: PropTypes.bool,
    fileButton: PropTypes.bool,
    spin: PropTypes.bool,
    loaderSize: PropTypes.number,
    children: PropTypes.node,
    className: PropTypes.string,
};

export default RegularButton;
